<template>
	<div class="cms-list" ref="cmsListRef">
		<Spinner v-show="loading" />
		<ul class="grid-equalHeight ul--nostyling cms-list__items">
			<li
				class="col-12_md-6 cms-list__col list__col"
				v-for="item in listItems"
				:key="item.Id"
			>
				<CmslistItem
					:data="item"
					:hideImages="dataProps.hideimages"
				></CmslistItem>
			</li>
		</ul>
		<div v-if="dataProps.showpaging == 'True'" class="col-12 text--center">
			<pagination
				:totalItems="totalItems"
				:pageSize="parseInt(dataProps.pagesize)"
				:currentPage="parseInt(pageIndex)"
				@changePageIndex="changePageIndex"
				:disableScrollToTop="true"
				:ariaLabelPaginationGotoPage="
					dataProps.arialabelpaginationgotopage
				"
				:ariaLabelPaginationNav="dataProps.arialabelpaginationnav"
				:ariaLabelPaginationNext="dataProps.arialabelpaginationnext"
				:ariaLabelPaginationPrev="dataProps.arialabelpaginationprev"
				:ariaLabelPaginationActivePage="
					dataProps.arialabelpaginationactivepage
				"
			></pagination>
		</div>
	</div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import Spinner from "../../../shared/script/vue/Spinner.vue";
import Pagination from '../pagination/pagination.vue';
import axios from "axios";
import CmslistItem from './cmsListItem.vue';

const apiurl = ref("");
const listItems = ref([]);
const filters = ref([]);
const pageIndex = ref(0);
const loading = ref(false);
const totalItems = ref(0);
const dataProps = ref({});

const cmsListRef = ref("cmsListRef");

onMounted(() => {
	dataProps.value = cmsListRef.value?.parentElement?.dataset;
	apiurl.value = dataProps.value.apiurl;
	checkPageIndex();
	fetchData(false);
});

const fetchData = async (setQueryString = true) => {
	loading.value = true;
	try {
		let response = await axios.get(apiurl.value, {
			params: {
				ContentId: dataProps.value.contentid,
				WidgetKey: dataProps.value.widgetkey,
				PageIndex: pageIndex.value,
				Filters: filters.value,
			},
		});

		if (response.status == 200) {
			listItems.value = response.data.items;
			totalItems.value = response.data.total;

			if (response.data.filters && response.data.filters.length) {
				filters.value = response.data.filters;
			}
		} else {
			listItems.value = [];
		}
		loading.value = false;
		if (setQueryString) {
			utilities.setQueryStringParameter("pageIndex", pageIndex.value);
		}
		return response;
	} catch (err) {
		console.warn(err);
		loading.value = false;
		return false;
	}
};

const changePageIndex = (index) => {
	let indexPlusOne = index + 1;
	if (
		indexPlusOne >= 1 &&
		indexPlusOne <= Math.ceil(totalItems.value / dataProps.value.pagesize)
	) {
		pageIndex.value = index;
		fetchData();
	}
};

const checkPageIndex = () => {
	const urlParams = new URLSearchParams(window.location.search);
	const pageIndexParam = urlParams.get("pageIndex");
	if (pageIndexParam) {
		pageIndex.value = parseInt(pageIndexParam, 10);
	}
};
</script>

<style lang="scss" scoped></style>
